import { motion } from "framer-motion";

/**
 * Editorial slow marquee. Duplicates the phrase seamlessly and uses the
 * Cormorant serif at large size to read as a magazine banner. Direction:
 * "left" (default) or "right".
 */
export const Marquee = ({ words = [], direction = "left", speed = 60 }) => {
  const strip = words.join("  ·  ") + "  ·  ";
  const distance = direction === "left" ? "-50%" : "50%";

  return (
    <div
      data-testid="marquee"
      aria-hidden
      className="relative overflow-hidden border-y border-q5 bg-[#0A0A0A] py-6 md:py-8"
    >
      <motion.div
        initial={{ x: 0 }}
        animate={{ x: distance }}
        transition={{ duration: speed, repeat: Infinity, ease: "linear" }}
        className="flex whitespace-nowrap font-serif-q5 text-white/85 text-5xl md:text-7xl leading-none tracking-tight"
        style={{ willChange: "transform" }}
      >
        <span className="pr-12">{strip}{strip}</span>
        <span className="pr-12">{strip}{strip}</span>
      </motion.div>
    </div>
  );
};
